<template>
  <div class="address-inputs">
    <UIInput
      class="span-3"
      :title="$t('Address')"
      :value="localFullAddress.address"
      @input="updateFullAddress('address', $event)"
      required
    />
    <UIInput
      class="span-3"
      :title="$t('Address 2')"
      :value="localFullAddress.address2"
      @input="updateFullAddress('address2', $event)"
    />
    <UIInput
      class="span-2"
      :title="$t('City')"
      :value="localFullAddress.city"
      @input="updateFullAddress('city', $event)"
      required
    />
    <UIInput
      class="span-2"
      :title="$t('Postal Code / ZIP')"
      :value="localFullAddress.postalCode"
      @input="updateFullAddress('postalCode', $event)"
      required
    />
    <UISelect
      class="span-2"
      :title="$t('State')"
      :value="localFullAddress.state"
      @change="updateFullAddress('state', $event)"
      :disabled="disableRegionSelect"
    >
      <option v-for="region in regions.filter(x => x.countryCode === localFullAddress.country)" :key="region.isoRegionCode" :value="region.isoRegionCode">{{ region.name }}</option>
    </UISelect>
    <UISelect
      class="span-6"
      :title="$t('Country')"
      :value="localFullAddress.country"
      @change="updateFullAddress('country', $event)"
      :instructions="(disableCountrySelect) ? $t('Contact Support to Modify Country.') : null"
      :disabled="disableCountrySelect"
      required
    >
      <option v-for="country in countries" :key="country.cca3" :value="country.cca3">{{ country.name }}</option>
    </UISelect>
  </div>
</template>

<script>
import { reactive } from '@vue/composition-api';
import UIInput from './UIInput';
import UISelect from './UISelect';

export default {
  name: 'UIAddressInputs',
  props: {
    fullAddress: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    regions: {
      type: Array,
      required: true,
    },
  },
  components: {
    UIInput,
    UISelect,
  },
  setup (props, { emit }) {
    const localFullAddress = reactive(props.fullAddress);
    const disableRegionSelect = reactive(!props.regions.some(x => x.countryCode === props.fullAddress.country));

    function updateFullAddress (type, event) {
      const previousCountry = localFullAddress.country;
      localFullAddress[type] = event.target.value;
      this.disableRegionSelect = !props.regions.some(x => x.countryCode === localFullAddress.country);
      if (this.disableRegionSelect || localFullAddress.country !== previousCountry) {
        localFullAddress.state = null;
      }
      emit('update:fullAddress', localFullAddress);
    }

    const disableCountrySelect = props.fullAddress.country.length > 0;

    return {
      localFullAddress,
      updateFullAddress,
      disableCountrySelect,
      disableRegionSelect,
    };
  },
};
</script>

<style lang="postcss" scoped>
.address-inputs {
  display: grid;
  grid-gap: var(--spacingMd);
}
</style>
